import { render, staticRenderFns } from "./Gun.vue?vue&type=template&id=1f4d5b74&"
import script from "./Gun.vue?vue&type=script&lang=js&"
export * from "./Gun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports